import { ReactElement } from "react";
import styles from "rivals/components/shared/Icons/Icons.module.scss";
import { IconProps } from "rivals/components/shared/Icons/iconPropsTypes";

const AlertCheckmark = ({
  height = "24px",
  width = "24px",
  fillBg = styles.corn,
  fill = styles.brownTumbleweed
}: IconProps): ReactElement => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 16 16"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_11908_3004)" id="Alert Icon">
        <path
          d="M8 16C12.4182 16 16 12.4182 16 8C16 3.58172 12.4182 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4182 3.58172 16 8 16Z"
          fill={fillBg}
          id="Vector"
        />
        <path
          clipRule="evenodd"
          d="M11.0214 5.6001L11.6858 6.34751L6.83336 10.6607L4 7.82735L4.7071 7.12025L6.87374 9.28687L11.0214 5.6001Z"
          fill={fill}
          fillRule="evenodd"
          id="Vector_2"
        />
      </g>
      <defs>
        <clipPath id="clip0_11908_3004">
          <rect fill="white" height={height} width={width} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AlertCheckmark;
